import { render } from "./S73045.vue?vue&type=template&id=9fddf204"
const script = {}
script.render = render

export default script